import React from 'react';
import { Attribution as ReactOlAttribution } from '../react-ol';
export var Attribution = _ref => {
  var {
    collapsed
  } = _ref;
  return /*#__PURE__*/React.createElement(ReactOlAttribution, {
    collapsed: collapsed
  });
};